import React from 'react';
import { motion } from 'framer-motion';
export function HookSection() {
  return <section className="py-12 sm:py-20 px-4 bg-[#050508] relative border-y border-white/5" data-id="element-71">
      <div className="max-w-3xl mx-auto" data-id="element-72">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="space-y-5 sm:space-y-8 text-base sm:text-xl md:text-2xl text-gray-300 leading-relaxed" data-id="element-73">
          <p className="italic font-medium text-white text-center text-xl sm:text-3xl mb-6 sm:mb-12" data-id="element-74">
            "Are you tired of waiting for the truth to arrive by mail?"
          </p>

          <p className="italic text-gray-400 text-center mb-6 sm:mb-12" data-id="element-75">
            Time is running out and the battle for our culture is happening
            right now — on your phone, on your tablet, and in your mind.
          </p>

          <p data-id="element-76">
            That's why we digitized Charlie Kirk's legacy. No shipping costs, no
            customs delays, and no censorship.{' '}
            <strong className="text-white" data-id="element-77">
              One click and the manifesto is yours.
            </strong>
          </p>

          <p className="font-oswald text-xl sm:text-3xl text-brand-gold text-center pt-4 sm:pt-8 uppercase tracking-wide" data-id="element-78">
            Zero wait time. Maximum impact.
          </p>
        </motion.div>
      </div>
    </section>;
}